import { twMerge } from 'tailwind-merge'

export function cn(
  ...classes: Array<string | false | null | undefined>
): string {
  return twMerge(classes.filter(Boolean).join(' '))
}

export function formatNumber(n: number): string {
  return n.toLocaleString('en-US')
}
